import { useEffect } from 'react';
import {
  TableAdapterHook,
  TableAdapterStatus,
  TableState,
} from 'src/components/DataTable/types/DataTable';
import { IErrorResponse } from 'src/utilities/shared-types';
import { SdkErrorResponse } from 'src/utilities/notifications';

export interface UseTableAdapterReturn<TData> {
  data: TData[];
  total: number;
  status: TableAdapterStatus;
  error?: IErrorResponse | SdkErrorResponse;
  isLoading: boolean;
  isEmpty: boolean;
  isError: boolean;
  hasSearchQuery: boolean;
}

export function useTableAdapter<TData, TFilters>(
  adapter: TableAdapterHook<TData, TFilters>,
  tableState: TableState<TFilters>
): UseTableAdapterReturn<TData> {
  const { data, total, status, error, fetch } = adapter(tableState);

  useEffect(() => {
    fetch(tableState);
  }, [fetch, tableState]);

  const isLoading = status === TableAdapterStatus.LOADING;
  const isEmpty = data.length === 0;
  const isError = status === TableAdapterStatus.ERROR;
  const hasSearchQuery = (tableState.query ?? '').length > 0;

  return {
    data,
    total,
    status,
    error,
    isLoading,
    isEmpty,
    isError,
    hasSearchQuery,
  };
}
